import React from "react";
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { animalAssets } from'../services/constant';
import { Divider } from "@mui/material";
import '../pages/animal/main.css';
import { AnimalAvatar } from "../services/AnimalAvatar";

export default function SiderBar({ data, sideState, setSideState }) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = () => {
        sideState === 1 ? setSideState(0) : setSideState(1);
    }
    const handlPopUp = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (
        <div className="sidebar">
            <div className="animal_card">
                {data.length > 1 ? (
                    <button onClick={(e) => { handlPopUp(e) }} className="avatar">
                        <img src={data[0] ? AnimalAvatar(data[0].type) : ''} alt="" className="mr-1"></img>
                        <img src={animalAssets.ic_arrow_down} alt="" className="font-center" />
                    </button>
                ) : (
                    <button className="avatar">
                        <img src={data[0] ? AnimalAvatar(data[0].type) : ''} alt="" className="mr-1"></img>
                    </button>
                )}
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    sx={{
                        marginTop: '1rem',
                        '& .MuiPaper-root': {
                            border: '1px solid #fff',
                            borderRadius: '1.5rem',
                            boxShadow: '0px 0px 25px 0px rgba(0, 0, 0, 0.1)'
                        },
                    }}
                >
                    <Typography sx={{ padding: '1.5rem 2.0rem 2rem 1.9rem' }}>
                        <div className="flex-colunm">
                            <div className="flex-row">
                                <img src={data[0] ? AnimalAvatar(data[0].type) : ''} alt="" className="mr-2" style={{ maxWidth: '4.7rem', width: '100%' }} />
                                <span className="font-16-500 font-center">{data[0] ? data[0].name : ''}</span>
                            </div>
                            {/* <div className="flex-row">
                                <img src={InActive_Animal} alt="" className="mr-2" />
                                <span className="font-16-500 font-center">Bigodes</span>
                            </div> */}
                        </div>
                    </Typography>
                </Popover>
                <div className="card_title font-22-500"> {data[0] ? data[0].name : ''} </div>
                <div className="card_count font-13-400">{data[0] ? data[0].age + " anos" : ''}  </div>
                <div className="card_detail1 font-14-400"> {data[0] ? data[0].type + "  " + data[0].gender + "  " + data[0].color : ''} </div>
                <div className="card_detail2 font-14-400"> {data[0] ? data[0].breed : ''}</div>
                <div className="card_info font-14-400">
                    {data[0] ? data[0].isActive === 1 ? (<img src={animalAssets.ic_setting_active} alt="" />) : (<img src={animalAssets.ic_setting} alt="" />) : ''}

                    <span className={data[0] ? data[0].isActive === 1 ? 'active' : '' : ''}>{data[0] ? data[0].microchip_number : ''}</span></div>
            </div>
            <Divider sx={{ borderColor: 'rgba(199, 212, 224, 1)', borderBottomWidth: '2px', marginTop: '3.2rem', width: '27.5rem', alignSelf: 'center' }} />
            <div className="animal_data ">
                {
                    sideState === 1 ?
                        (<><button className="data_add font-14-500 mb-1" onClick={() => handleClick()} >Dados da Apólice <img src={animalAssets.ic_arrow_right} className="data_add_icon" alt="" /></button><div className="mb-1"><button className="data_title font-14-400 mb-1" onClick={() => handleClick()}>Dados do animal</button></div></>)
                        :
                        (<><div className="mb-1"><button className="data_title font-14-400 font-left mb-1" onClick={() => handleClick()} >Dados da Apólice </button></div><button className="data_add font-14-500 mb-1" onClick={() => handleClick()}>Dados do animal <img src={animalAssets.ic_arrow_right} className="data_add_icon" alt="" /></button></>)
                }
                <div className="data_info font-14-400">Pedidos de pré-autorizações</div>
            </div>
            <div className="sidebar_bottom "><img src={animalAssets.sidebar_footer} alt="" className="justify-self-center mx-auto"/></div>
        </div>
    );
}